<template>
    <div class="sidebar-footer">
        <div class="boxAside">
            <div class="contentBox" v-if="displayAside">
                <h4 style="display: block; text-align: center; padding-bottom: 10px">
                    {{ dataAsideMenu.name }}
                </h4>
                <!-- {{ dataAsideMenu }} -->
                <div v-if="saveFood === false && dataAsideMenu.name !== ''">
                    <button class="btn btn-add-group btn-aside" @click="multisize()">
                        Multisize
                        <div class="btn-switch">
                            <div class="onoffswitch">
                                <input
                                    type="checkbox"
                                    id="sizes"
                                    v-model="swichMultisize"
                                    class="onoffswitch-checkbox"
                                />
                                <label class="onoffswitch-label" for="sizes">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </div>
                    </button> 
                    <br>                                     
                    <button class="btn btn-add-group btn-aside" @click="variant()">
                        Opciones
                        <div class="btn-switch">
                            <div class="onoffswitch">
                                <input
                                    type="checkbox"
                                    id="catsize"
                                    v-model="swichVariant"
                                    class="onoffswitch-checkbox"
                                />
                                <label class="onoffswitch-label" for="catsize">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </div>
                    </button> 
                </div>

                <div v-if="dataAsideMenu.opts === 'multizise' && dataAsideMenu.type === 'category'">
                    <div class="form-group">
                        <div
                            class="items-sizes"
                            v-for="(i, index) in dataAsideMenu.sizesList"
                            :key="index"
                        >
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Tamaño del nombre"
                                style="width: 100% !important"
                                maxlength="20"
                                v-model="i.name"
                            />
                            <button
                                type="button"
                                class="btn btn-danger btn-sm"
                                style="width: 30px"
                                v-if="dataAsideMenu.existFoods === false && index > 0"
                                @click="deleteSize(i, index)"
                            >
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <div v-if="dataAsideMenu !== null">
                            <button
                                type="button"
                                class="btn btn-info btn-sm"
                                style="width: auto; margin-top: 5px"
                                v-if="
                                    dataAsideMenu.sizesList.length < 4 &&
                                    dataAsideMenu.existFoods === false
                                "
                                @click="addSize()"
                            >
                                <i class="fas fa-plus"></i> {{ $t("lang.label_add") }}
                            </button>
                        </div>
                        <button
                            type="button"
                            class="btn btn-dark"
                            style="margin-top: 20px"
                            @click="Saveitems"
                            v-if="dataAsideMenu.swich"
                            :disabled="btnSave"
                        >
                            {{ btnname }}
                        </button>
                    </div>
                </div>
                <div
                    v-if="
                        dataAsideMenu.existFoods === true &&
                        dataAsideMenu.swich === false &&
                        dataAsideMenu.id_category > 0 &&
                        variants === false &&
                        dataAsideMenu.opts === 'multizise' &&
                        dataAsideMenu.type === 'food'
                    "
                >
                    <!-- validar solo para comidas o foods-->
                    <extras></extras>
                </div>
                <div v-if="dataAsideMenu.opts === 'variant' && variants === true">
                    <!-- select or create a meal to add variant options -->
                    seleccione o cree una comida para agregar opciones variantes
                    <variantFormAside
                        v-if="
                            dataAsideMenu.opts === 'variant' &&
                            dataAsideMenu.type === 'food'
                        "
                    ></variantFormAside>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import extras from "@/components/dimenu/menu/extras";
import variantFormAside from "@/components/dimenu/menu/variantFormAside";
import EventBus from "@/eventBus";
import { mapGetters } from "vuex";
export default {
    name: "menu_aside",
    components: {
        extras,
        variantFormAside,
    },
    data () {
        return {
            btnSave: false,
            isLoading: false,
            btnname: window.lang2.label_save,
            indexCat: 0,
            displayAside: false,
            OldsizesList: [],
            variants: false,
            swichMultisize:false,
            swichVariant:false,
            saveFood:false
        }
    },
    mounted () {
        EventBus.$on("ClearAside", () => {
            this.displayAside = false;
            //EventBus.$off('ClearAside');
        });
    },  
    methods: {
        multisize() {                  
            this.dataAsideMenu.swich = true
            this.dataAsideMenu.existFoods = false
            this.dataAsideMenu.existSizes = false
            let sizesList = this.dataAsideMenu.sizesList
            this.dataAsideMenu.opts = "multizise"
            this.commits("multizise")       
            this.variants = false
        },
        commits(actions){
            let t = this 
            let id = this.dataAsideMenu.id;
            let data = {
                function: "variants",
                dat: true,
                id: id,
                actions: actions,
            };
            this.$store.commit("setvariantData", data);
        },        
        variant() {          
            let i = this.dataAsideMenu
            let actions = "variant";
            this.dataAsideMenu.swich = false;
            this.dataAsideMenu.existFoods = true;
            this.dataAsideMenu.existSizes = true;
            this.variants = true;
            this.dataAsideMenu.opts = "variant"
            // this.commit(actions)
        },
        commit(actions){
            let t = this 
            let id = this.dataAsideMenu.id;
            let data = {
                function: "variants",
                dat: true,
                id: id,
                actions: actions,
                swich:t.swichVariant,
            };
            this.$store.commit("setvariantData", data);
        },
        addSize() {
            this.dataAsideMenu.sizesList.push({ id: 0, name: "" });
        },
        deleteSize(i, index) {
            if (i.id !== 0) {
                this.OldsizesList.push(i.id);
            }
            this.dataAsideMenu.sizesList.splice(index, 1);
        },
        Saveitems() {
            this.btnSave = true;
            this.isLoading = true;
            this.btnname = "cargando...";
            window.master
                .post("menu/category/size", {
                    org_id: window.localuserdata,
                    user_id: window.localAccountID,
                    category_id: this.get_menuCatActive.cat.id,
                    items: this.dataAsideMenu.sizesList,
                    oldSizes: JSON.stringify(this.OldsizesList),
                })
                .then((response) => {
                    this.OldsizesList = [];
                    this.isLoading = false;
                    this.btnSave = false;
                    let send = {
                        nsizes: response.data.sizes,
                        key: this.indexCat,
                        retorno: 1,
                    };
                    this.$store.commit("SET_RETORNO_ASIDE", send);
                    if (response.data.sizes.length > 1) {
                        this.dataAsideMenu.swich = true;
                        this.dataAsideMenu.existSizes = true;
                        this.dataAsideMenu.existFoods = false;
                    } else {
                        this.dataAsideMenu.swich = false;
                        this.dataAsideMenu.existSizes = false;
                        this.dataAsideMenu.existFoods = false;
                    }
                    this.dataAsideMenu.sizesList = response.data.sizes;
                    this.btnname = window.lang2.label_saved;

                    let t = this
                    let id = this.dataAsideMenu.id;
                    let data = {
                        function: "variants",
                        dat: true,
                        id: id,
                        sizesList:t.dataAsideMenu.sizesList,
                        activeFoodCero:true,
                        swich:t.swichMultisize,
                        actions: "multizise",
                    };
                    this.$store.commit("setvariantData", data);                    
                })
                .catch((error) => {
                    this.btnSave = false;
                    console.log(error);
                });
        },
        DisplaySelect() {
            this.variants = false;
            this.dataAsideMenu.swich = !this.dataAsideMenu.swich;
            if (this.dataAsideMenu.swich === true) {
                this.dataAsideMenu.opts = "multizise";
            }
            if (
                this.get_menuCatActive.cat.sizes.length === 1 &&
                this.dataAsideMenu.sizesList.length === 0
            ) {
                this.dataAsideMenu.sizesList.push({
                    id: this.get_menuCatActive.cat.sizes[0].id,
                    name: this.get_menuCatActive.cat.sizes[0].name,
                });
            }
            let id = this.dataAsideMenu.id;
            if (this.dataAsideMenu.swich === true) {
                let data = {
                    function: "variants",
                    dat: false,
                    id: id,
                    actions: "multizise",
                };
                this.$store.commit("setvariantData", data);
            }
        },
    },
    computed: {
        ...mapGetters(["get_menuCatActive", "dataAsideMenu", "getvariantData"]),
    },
    watch: {
        'swichVariant': function(){
            if (this.swichVariant === true) {
                this.commit("variant")                
                if (this.swichMultisize === true) {
                    this.swichMultisize = false
                }
            } else {
                this.commit("variant")
            }
            if (this.swichMultisize === false && this.swichVariant === false) {
                this.dataAsideMenu.opts = ""
            }             
        },
        'swichMultisize': function(){
            if (this.swichMultisize === true) {
                if (this.swichVariant === true) {
                    this.swichVariant = false
                }
            } 
            if (this.swichMultisize === false && this.swichVariant === false) {
                this.dataAsideMenu.opts = ""
            }             
        },        
        get_menuCatActive(val) {
            //this.displayAside = true
            this.indexCat = val.key;
            this.btnname = window.lang2.label_save;
        },
        dataAsideMenu() {
            this.displayAside = true;
            if (this.dataAsideMenu.opts === "variant") {
                this.variants = true;
                this.saveFood = true
            }
            if (this.dataAsideMenu.opts === "multizise") {
                this.variants = false;
                this.saveFood = true
            }
            if (this.dataAsideMenu.opts === "") {
                this.saveFood = false
                this.swichVariant = false
                this.swichMultisize = false                
            }            
            if (this.dataAsideMenu === []) {
                this.swichVariant = false
                this.swichMultisize = false
                this.saveFood = true             
            }
            // console.log('aside dataAsideMenu', this.dataAsideMenu)
        },
        getvariantData() {
            // console.log(this.getvariantData);
            let functions = this.getvariantData.function;
            let actions = this.getvariantData.actions;
            if (functions === "saveVariantsFood") {
                this.saveFood = true;
                this.swichVariant = false
                this.swichMultisize = false
                this.actions = actions 
                this.dataAsideMenu.opts = actions           
            }                        
            if (functions === "variantsFood") {
                this.swichVariant = false
                this.swichMultisize = false
                this.dataAsideMenu.opts = ''
                let data = {
                    function: "variants",
                    dat: true,
                    actions: null,
                };
                this.$store.commit("setvariantData", data);                 
            }            
        },
    },
}
</script>

<style lang="scss" scoped>
.items-sizes {
    display: flex;
    margin-top: 10px;
}
.boxAside {
    position: absolute;
    height: calc(100vh - 10vw);
    overflow: hidden;
    overflow-y: scroll;
    width: 100%;
    padding-right: 15px;
    padding-bottom: 20px;
}
.boxAside::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    width: 10px;
    background-color: #f5f5f5;
}
.boxAside::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
}
.boxAside::-webkit-scrollbar-thumb {
    background-color: #222223;
}
.contentBox {
    input {
        border: 1px solid #b1b1b1;
    }
    button {
        width: 100%;
    }
}
.cuerpo-column2 {
    display: flex;
    flex-direction: column;
    flex: 0 0 320px;
    overflow: hidden;
    z-index: 20;
    background: #fff;
    border-left: 1px solid #d5d5d3;
    box-shadow: 0 1px 3px rgba(0, 1, 1, 0.25);
}
.sidebar-header {
    font-weight: 700;
    font-size: 17px;
    color: #727272;
    display: flex;
    background: #eee;
    padding: 0.4rem 1rem;
}
.sidebar-content {
    overflow: auto;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}
.sidebar-footer {
    flex: 1000 1 auto;
    margin: 15px;
    position: relative;
    margin-right: 0;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
.btn-add-group:hover {
    color: #212529;
    background-color: #e0e0e0;
    border-color: #b3b2b2;
}
.btn-aside {
    max-width: 200px;
    margin: 0 auto;
    display: block;
}
/*SWICHT*/
.btn-switch {
    display: block;
    margin-top: 3%;
    margin-right: 30%;
    margin-left: 20%;
}
.onoffswitch {
    position: relative;
    // width: 60px;
    width: 95px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #585858;
    border-radius: 20px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 20px;
    padding: 0;
    line-height: 20px;
    font-size: 12px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Encendido";
    padding-right: 10px;
    background-color: #585858;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Apagado";
    padding-right: 10px;
    background-color: #d65353;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 15px;
    height: 15px;
    margin: 6px;
    background: #fff;
    position: absolute;
    top: -3px;
    bottom: 0;
    // right: 33px;
    right: inherit;
    border: 1px solid #585858;
    border-radius: 20px;
    transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.mascara {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 0;
    top: -1px;
    left: 0;
    z-index: 1;
}
</style>
